import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, } from '@angular/core';
import {ApiPaths} from 'src/enums/api-paths';
import {ConfigService} from '../config.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {

  constructor(private http: HttpClient,
  ) {
  }

  lookUpCountry(query: string, page: number): Observable<any> {

    const queryParameters = new HttpParams()
      .set('name', query)
      .set('page', page);
    const url = `${ConfigService.settings.baseUrlNoApi}/${ApiPaths.LookUpCountry}`;

    return this.http.get<any>(
      url,
      {params: queryParameters, withCredentials: true}
    );
  }

  lookUpNameDocument(issuer: string, docType: string, page: number): Observable<any> {
    const queryParameters = new HttpParams()
      .set('name',  issuer)
      .set('document_type', docType)
      .set('page', page);

    const url = `${ConfigService.settings.baseUrlNoApi}/${ApiPaths.LookUpNameDoc}`;

    return this.http.get<any>(
      url,
      {params: queryParameters, withCredentials: true}
    );
  }

  lookUpProvinces(query: string, country: string, page: number): Observable<any> {

    const queryParameters = new HttpParams()
      .set('name', query)
      .set('country', country)
      .set('page', page);
    const url = `${ConfigService.settings.baseUrlNoApi}/${ApiPaths.LookUpProvinces}`;

    return this.http.get<any>(
      url,
      {params: queryParameters, withCredentials: true}
    );
  }

  lookUpCities(query: string, country: string, prov: string, page: number): Observable<any> {

    const queryParameters = new HttpParams()
      .set('name', query)
      .set('country', country)
      .set('province', prov)
      .set('page', page);
    const url = `${ConfigService.settings.baseUrlNoApi}/${ApiPaths.LookUpCity}`;

    return this.http.get<any>(
      url,
      {params: queryParameters, withCredentials: true}
    );
  }
}
